var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenbtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 0H8C5.87902 0.00243493 3.8456 0.846072 2.34584 2.34584C0.846072 3.8456 0.00243493 5.87902 0 8V40C0.00243493 42.121 0.846072 44.1544 2.34584 45.6542C3.8456 47.1539 5.87902 47.9976 8 48H26C30.7722 47.9945 35.3474 46.0963 38.7218 42.7218C42.0963 39.3474 43.9945 34.7722 44 30V8C43.9976 5.87902 43.1539 3.8456 41.6542 2.34584C40.1544 0.846072 38.121 0.00243493 36 0ZM30 32H14C13.4696 32 12.9609 31.7893 12.5858 31.4142C12.2107 31.0391 12 30.5304 12 30C12 29.4696 12.2107 28.9609 12.5858 28.5858C12.9609 28.2107 13.4696 28 14 28H30C30.5304 28 31.0391 28.2107 31.4142 28.5858C31.7893 28.9609 32 29.4696 32 30C32 30.5304 31.7893 31.0391 31.4142 31.4142C31.0391 31.7893 30.5304 32 30 32ZM30 24H14C13.4696 24 12.9609 23.7893 12.5858 23.4142C12.2107 23.0391 12 22.5304 12 22C12 21.4696 12.2107 20.9609 12.5858 20.5858C12.9609 20.2107 13.4696 20 14 20H30C30.5304 20 31.0391 20.2107 31.4142 20.5858C31.7893 20.9609 32 21.4696 32 22C32 22.5304 31.7893 23.0391 31.4142 23.4142C31.0391 23.7893 30.5304 24 30 24ZM30 16H14C13.4696 16 12.9609 15.7893 12.5858 15.4142C12.2107 15.0391 12 14.5304 12 14C12 13.4696 12.2107 12.9609 12.5858 12.5858C12.9609 12.2107 13.4696 12 14 12H30C30.5304 12 31.0391 12.2107 31.4142 12.5858C31.7893 12.9609 32 13.4696 32 14C32 14.5304 31.7893 15.0391 31.4142 15.4142C31.0391 15.7893 30.5304 16 30 16Z",
    fill: "url(#paint0_linear_383_3732)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_383_3732",
    x1: 0,
    y1: 24,
    x2: 44,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636060"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenbtn);
export default __webpack_public_path__ + "static/media/menbtn.6a45fe99331693e573ec2bee359d1280.svg";
export { ForwardRef as ReactComponent };